document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
    form.addEventListener('submit', event => {
      try {
        // 🔹 NICHT verhindern! Kein preventDefault!
        // Tracking soll "fire and forget" sein.

        const formData = new FormData(form);
        const variantId = String(formData.get('id') || '').trim();
        const quantity  = parseInt(formData.get('quantity') || '1', 10) || 1;
        const productTitle =
          document.querySelector('h1.product__title, .product-title')?.innerText?.trim() ||
          document.title;

        // ✅ SKU über globale Map aus buy-buttons.liquid
        let sku = (window.variantSKUs && variantId) ? window.variantSKUs[variantId] : null;
        if (!sku) {
          sku =
            form.querySelector('[name="sku"]')?.value ||
            document.querySelector('#tracking-sku')?.dataset?.sku ||
            'unbekannt';
        }

        sku = String(sku).trim();
        const sku_base = sku.replace(/\D/g, '') || null;

        // Session-ID generieren
        let sessionId = localStorage.getItem('cart_session_id');
        if (!sessionId) {
          sessionId = crypto.randomUUID();
          localStorage.setItem('cart_session_id', sessionId);
        }

        // 🔹 Asynchrones Tracking (fire and forget)
        fetch('https://wawi.sk-shop24.de/srv/tracking/add_to_cart', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            sku,
            sku_base,
            variant_id: variantId,
            quantity,
            product_title: productTitle,
            session_id: sessionId
          })
        })
        .then(() => console.log('📦 Tracking gesendet:', { sku, sku_base, variantId, quantity, productTitle }))
        .catch(err => console.warn('⚠️ Tracking Add-to-Cart fehlgeschlagen:', err));

        // 🔹 Sofort weiterlaufen lassen (Shopify übernimmt Add-to-Cart)
      } catch (err) {
        console.warn('⚠️ Tracking Add-to-Cart Fehler:', err);
      }
    }, { passive: true }); // ⚡ passive = true = nie blockieren
  });
});
